import React from 'react';

interface CardProps {
  children: React.ReactNode;
  className?: string;
  title?: string;
  description?: string;
}

export const Card: React.FC<CardProps> = ({ children, className = '', title, description }) => {
  return (
    <div className={`bg-surface shadow rounded-lg border border-line overflow-hidden ${className}`}>
      {(title || description) && (
        <div className="px-6 py-5 border-b border-line">
          {title && <h3 className="text-lg font-medium text-content">{title}</h3>}
          {description && <p className="mt-1 text-sm text-content-muted">{description}</p>}
        </div>
      )}
      {children}
    </div>
  );
};
